import { render, staticRenderFns } from "./cider_card.vue?vue&type=template&id=40351ed2&scoped=true"
import script from "./cider_card.vue?vue&type=script&lang=js"
export * from "./cider_card.vue?vue&type=script&lang=js"
import style0 from "./cider_card.vue?vue&type=style&index=0&id=40351ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40351ed2",
  null
  
)

export default component.exports